__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "it_incubator_personal_page_respect_front";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@it-incubator/ui-kit", "1.0.8", () => (Promise.all([__webpack_require__.e(660), __webpack_require__.e(345), __webpack_require__.e(325), __webpack_require__.e(58), __webpack_require__.e(196), __webpack_require__.e(295)]).then(() => (() => (__webpack_require__(1279))))));
			register("@tanstack/react-query", "5.8.1", () => (Promise.all([__webpack_require__.e(684), __webpack_require__.e(58)]).then(() => (() => (__webpack_require__(4684))))));
			register("axios", "1.6.1", () => (__webpack_require__.e(559).then(() => (() => (__webpack_require__(9559))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(638), __webpack_require__.e(376)]).then(() => (() => (__webpack_require__(9638))))));
			register("react-redux", "8.1.3", () => (Promise.all([__webpack_require__.e(942), __webpack_require__.e(345)]).then(() => (() => (__webpack_require__(6942))))));
			register("react-router-dom", "6.18.0", () => (Promise.all([__webpack_require__.e(628), __webpack_require__.e(253)]).then(() => (() => (__webpack_require__(8628))))));
			register("react-toastify", "9.1.3", () => (Promise.all([__webpack_require__.e(170), __webpack_require__.e(515)]).then(() => (() => (__webpack_require__(170))))));
			register("react", "18.2.0", () => (__webpack_require__.e(461).then(() => (() => (__webpack_require__(6461))))));
			initExternal(8524);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};